import './index.global.scss';

export {RichContentEditor, RichContentEditorModal} from 'wix-rich-content-editor';
export {createLinkPlugin} from 'wix-rich-content-plugin-link';
export {createHashtagPlugin} from 'wix-rich-content-plugin-hashtag';
export {createImagePlugin, ModalsMap as imageModals} from 'wix-rich-content-plugin-image';
export {createVideoPlugin, ModalsMap as videoModals} from 'wix-rich-content-plugin-video';
export {createGalleryPlugin, ModalsMap as galleryModals} from 'wix-rich-content-plugin-gallery';
export {createDividerPlugin} from 'wix-rich-content-plugin-divider';
export {createHtmlPlugin} from 'wix-rich-content-plugin-html';
